<template>
  <v-card
    flat
    class="mx-auto rounded-lg"
    min-height="240"
    @click="navigateToCourseDetailsPage(course._id)"
  >
    <div class="pa-3">
      <v-img
        height="140"
        :src="
          course.training && course.training.images
            ? getImage(course.training.images)
            : null
        "
        lazy-src="@/app/core-module/assets/images/logo_placeholder.png"
        cover
      />
    </div>

    <v-card-title class="pt-0 pb-3">
      <p
        class="text-start body-2 textLight--text ma-0 text-ellipse-1"
        style="opacity: 0.8"
      >
        {{ getLocalisedValue(course.training.title) }}
      </p>
    </v-card-title>

    <v-card-text class="pt-0 pb-3">
      <div class="d-flex align-end">
        <v-icon color="primary"> mdi-book-open-variant</v-icon>

        <span class="primary--text ms-3">
          {{ course.totalContents }}

          {{ $t("course.assignedCourses.lessons") }}
        </span>
      </div>
    </v-card-text>

    <v-card-text class="pt-0 pb-3">
      <div class="d-flex justify-space-between">
        <span class="body-2 textLight--text text-truncate" style="opacity: 0.8">
          {{ $t("course.assignedCourses.dueOn") }}

          {{
            course.endDate
              ? moment(parseInt(course.endDate)).format("DD MMM YYYY")
              : "-"
          }}
        </span>

        <v-icon size="20">mdi-arrow-right</v-icon>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    course: {
      type: Object,
    },
  },
  data() {
    return {
      data: this.course,
    };
  },
  methods: {
    navigateToCourseDetailsPage(trainingRegistrationId) {
      this.$router.push({
        name: "CourseDetails",
        params: { trainingRegistrationId },
      });
    },
  },
};
</script>
